/**
 * `/` — not a page, a decision.
 *
 * `.docs/08-web-foundation.md` §5: "redirect: staff → `/studio`, client → `/app`,
 * none → `/login`." It has no component at all: `beforeLoad` always throws, so
 * there is never a frame where the root URL renders something and then moves.
 */

import { createFileRoute, redirect } from '@tanstack/react-router'

import { homeFor } from '../auth/guards.js'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    throw redirect({ to: homeFor(context.session.principal) })
  },
})
